import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { JobStatusModule } from '../../job-status/job-status.module';
import { JobStatusCellRendererComponent } from './job-status-cell-renderer.component';

@NgModule({
  imports: [CommonModule, JobStatusModule],
  declarations: [JobStatusCellRendererComponent],
  exports: [JobStatusCellRendererComponent],
})
export class JobStatusCellRendererModule {}
